import {
  request
} from './request'

// 网站信息
function siteConfig() {
  return request({
    method: 'get',
    url: '/api/v1/index/siteConfig'
  })
}

export {
  siteConfig
}



// WEBPACK FOOTER //
// ./src/api/foot.js